
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-18930.75 -24257.002 6.283 12.77"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Symbol 265 – 1"}},[_c('path',{attrs:{"d":"M-18926.346-24257.001a1.351 1.351 0 1 1-1.351 1.351 1.351 1.351 0 0 1 1.351-1.351z","fill":"#2386db"}}),_c('path',{attrs:{"d":"M-18930-24251.414l2.407-1.367a.66.66 0 0 1 .981.713l-1.842 6.27a.671.671 0 0 0 .981.713l2.258-1.337","fill":"none","stroke":"#2386db","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","stroke-width":"1.5"}})])])
          )
        }
      }
    